import { Button, Dialog, styled } from '@nextiva/next-ui-components';

export const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 8px;
    padding: 32px;
    width: 411px;
    gap: 24px;
  }
  & .MuiDialogContent-root,
  div.MuiDialogActions-root {
    padding: 0;
  }
`;
export const ButtonStyled = styled(Button)`
  &.MuiButton-sizeMedium {
    padding: 12px 24px;
    margin-left: 16px;
  }
`;
